import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoAlertError = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M1.2 0C0.537258 0 0 0.537259 0 1.2L0 10.8C0 11.4627 0.537259 12 1.2 12H10.8C11.4627 12 12 11.4627 12 10.8V1.2C12 0.537258 11.4627 0 10.8 0L1.2 0ZM5 2.2C5 1.97909 5.17909 1.8 5.4 1.8L6.6 1.8C6.82091 1.8 7 1.97909 7 2.2V6.6C7 6.82091 6.82091 7 6.6 7H5.4C5.17909 7 5 6.82091 5 6.6V2.2ZM5 8.2C5 7.97909 5.17909 7.8 5.4 7.8H6.6C6.82091 7.8 7 7.97909 7 8.2V9.4C7 9.62091 6.82091 9.8 6.6 9.8H5.4C5.17909 9.8 5 9.62091 5 9.4V8.2Z",
		fill: "#CC0000"
	})]
});
const ForwardRef = forwardRef(SvgIcoAlertError);
export { ForwardRef as ReactComponent };
